// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectComp .ant-select {
  /* padding: 19px; */
  /* min-height: 40px !important; */
  /* max-height: auto; */
}
`, "",{"version":3,"sources":["webpack://./src/commons/Select/Select.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;AACxB","sourcesContent":[".SelectComp .ant-select {\n  /* padding: 19px; */\n  /* min-height: 40px !important; */\n  /* max-height: auto; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
